export default __webpack_public_path__ + "static/media/d7.02653116.jpg";